import {
  afterNextRender,
  Directive,
  ElementRef,
  HostBinding,
  inject,
  Injector,
} from '@angular/core';

interface InkBarPosition {
  left: string;
  width: string;
}

@Directive({
  // this directive is being used as a component ? I don't want to mess it up so I just ignore the eslint error
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'tab-ink-bar',
})
export class TabInkBarDirective {
  private el = inject(ElementRef);
  private injector = inject(Injector);

  @HostBinding('class') tabInkBarClass = 'tab-ink-bar';

  alignToElement(element: HTMLElement) {
    afterNextRender(
      () => {
        this.setStyles(element);
      },
      { injector: this.injector }
    );
  }

  private setStyles(element: HTMLElement) {
    const position = this.getInkBarPosition(element);
    const inkBar: HTMLElement = this.el.nativeElement;

    inkBar.style.left = position.left;
    inkBar.style.width = position.width;
  }

  private getInkBarPosition(element: HTMLElement): InkBarPosition {
    return {
      left: `${element?.offsetLeft || 0}px`,
      width: `${element?.offsetWidth || 0}px`,
    };
  }
}
